import type { LeadModalState, OpenLeadModalAction } from 'modules/leads/types';
import { createReducer } from 'utils/ReduxUtils';

const initialState: LeadModalState = {
  visible: false,
  leadId: null,
};

const openModal = (state: LeadModalState, { payload: leadId }: OpenLeadModalAction): LeadModalState => ({
  ...state,
  leadId,
  visible: true,
});

const closeModal = (): LeadModalState => initialState;

/**
 * Builds the state of a modal opened on one lead.
 * @param openType the action that opens the modal on the lead in its payload
 * @param closeType the action that closes the modal
 * @param successType the request success that closes the modal once the action is done
 */
export const createLeadModalReducer = (openType: string, closeType: string, successType: string) =>
  createReducer<LeadModalState>(initialState, {
    [openType]: openModal,
    [closeType]: closeModal,
    [successType]: closeModal,
  });
